import { render } from "./CheckMark.vue?vue&type=template&id=705e7cc9&scoped=true"
import script from "./CheckMark.vue?vue&type=script&lang=js"
export * from "./CheckMark.vue?vue&type=script&lang=js"

import "./CheckMark.vue?vue&type=style&index=0&id=705e7cc9&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705e7cc9"]])

export default __exports__